<template>
  <div :class="isMobile?'mobile-fixed-box':'window-fixed-box'" v-if="visible">
    <div class="fixed-box" :class="'animate__animated '+animateDirection[direction]" :style="'width:'+(width==''?(isMobile?'100%':'60%'):(width+'px'))">
      <img src="@/assets/icon/close.svg" @click="()=>{
          this.$emit('close');
        }" class="dialog-close"/>
      <div class="dialog-title">{{title}}</div>
      <div class="dialog-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      visible:Boolean,
      title:String,
      direction:{
        type:String,
        default:''
      },
      width:{
        type:String,
        default:''
      },
    },
    data () {
      return{
        animateDirection:{
          '':'animate__fadeIn',
          left:'animate__fadeInLeft',
          right:'animate__fadeInRight',
          top:'animate__fadeInDown',
          down:'animate__fadeInUp',
        },
      }
    },
    computed:{
      ...mapGetters(['isMobile']),
    },
    mounted(){

    },
    methods:{
    }
  }
</script>
<style lang="scss" scoped>
  .window-fixed-box{background:rgba(0,0,0,0.7);width:100vw;height:100vh;position:fixed;left:0px;top:0px;z-index:998;display:flex;align-items:center;justify-content:center;
    .fixed-box{background:#fff;border-radius:12px;box-shadow:0 4px 16px rgba(0, 0, 0, 0.3);padding:16px;position:relative;
      .dialog-close{position:absolute;top:15px;z-index:9999;right:15px;cursor:pointer;width:20px;}
      .dialog-title{font-size:18px;font-family:"Nunito-SemiBold";padding:0px 16px;}
      .dialog-body{max-height:calc(80vh - 200px);overflow-y:auto;padding:0px 16px;margin:12px auto;}
    }
  }
  
  .mobile-fixed-box{width:100%;height:100%;position:fixed;left:0px;top:0px;z-index:9999;
    .fixed-box{background:#fff;position:relative;padding:16px;height:100vh;
      .dialog-close{position:absolute;top:15px;z-index:9999;right:15px;cursor:pointer;width:20px;}
      .dialog-title{font-size:18px;font-family:"Nunito-SemiBold";padding:0px 10px;height:30px;line-height:30px;}
      .dialog-body{height:calc(100vh - 70px);;overflow-y:auto;padding:0px 10px;box-sizing:border-box;margin-top:12px;}
    }
  }
</style>
